<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>

      <div class="form-group form-row">
        <label :for="safeId('rink')" class="col-sm-4 col-form-label">Platz</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('rink')" v-model="rink" :options="rinkOptions"
                         text-field="label" value-field="value">
          </b-form-select>
        </div>
      </div>

      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Paarung</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"
                         :label-fn="labelFn"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('color1')" class="col-sm-4 col-form-label">Color 1</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('color1')" v-model="color1" :options="colorOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title1')" class="col-sm-4 col-form-label">Name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title1')" v-model.lazy="title1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('club1')" class="col-sm-4 col-form-label">Club 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('club1')" v-model.lazy="club1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('score1')" class="col-sm-4 col-form-label">Score 1</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('score1')" v-model="score1" :options="scoreOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('color2')" class="col-sm-4 col-form-label">Color 2</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('color2')" v-model="color2" :options="colorOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title2')" class="col-sm-4 col-form-label">Name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title2')" v-model.lazy="title2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('club2')" class="col-sm-4 col-form-label">Club 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('club2')" v-model.lazy="club2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('score2')" class="col-sm-4 col-form-label">Score 2</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('score2')" v-model="score2" :options="scoreOptions">
          </b-form-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternColor1')" class="col-sm-4 col-form-label">Color 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternColor1')" v-model.lazy="patternColor1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTitle1')" class="col-sm-4 col-form-label">Title 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTitle1')" v-model.lazy="patternTitle1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternClub1')" class="col-sm-4 col-form-label">Club 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternClub1')" v-model.lazy="patternClub1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternScore1')" class="col-sm-4 col-form-label">Score 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternScore1')" v-model.lazy="patternScore1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternColor2')" class="col-sm-4 col-form-label">Color 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternColor2')" v-model.lazy="patternColor2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTitle2')" class="col-sm-4 col-form-label">Title 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTitle2')" v-model.lazy="patternTitle2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternClub2')" class="col-sm-4 col-form-label">Club 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternClub2')" v-model.lazy="patternClub2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternScore2')" class="col-sm-4 col-form-label">Score 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternScore2')" v-model.lazy="patternScore2">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group form-row">
          <label :for="safeId('allowSameColor')" class="col-sm-4 col-form-label">Allow same color</label>
          <div class="col-sm-8" style="padding-top: 5px">
            <b-form-checkbox :id="safeId('allowSameColor')" v-model="allowSameColor"></b-form-checkbox>
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData, mapTemplateData, mapTemplateOptions } from '../../utils/index'
import * as mutation from '../../store/mutation-types'

export default {
  name: 'swiss-wrestling-result-2024',
  mixins: [templateMixin],
  data () {
    return {
      rinkOptions: new Array(10).fill(null).map((v, i) => ({label: `${i + 1}`, value: i + 1}))
    }
  },
  computed: {
    ...mapOverlayData(['color1', 'color2', 'title1', 'title2', 'score1', 'score2', 'club1', 'club2']),
    ...mapTemplateData(['rink', 'datasetId', 'recordId']),
    ...mapTemplateData({
      /* eslint-disable no-template-curly-in-string */
      patternColor1: {default: '${p1_a_farbe}'},
      patternTitle1: {default: '${p1_lastName} ${p1_firstName} ${p1_a_sterne}'},
      patternClub1: {default: '${p1_a_verband}, ${p1_a_wohnort}'},
      patternScore1: {default: '${p1_a_note}'},
      patternColor2: {default: '${p2_a_farbe}'},
      patternTitle2: {default: '${p2_lastName} ${p2_firstName} ${p2_a_sterne}'},
      patternClub2: {default: '${p2_a_verband}, ${p2_a_wohnort}'},
      patternScore2: {default: '${p2_a_note}'}
      /* eslint-enable no-template-curly-in-string */
    }),
    ...mapTemplateOptions({'allowSameColor': false}),
    dataset () {
      if (!this.datasetId) return null
      return this.$store.getters.dataset(this.datasetId)
    },
    datasetColumns () {
      if (!this.dataset) return
      return this.dataset.columns || []
    },
    colorOptions () {
      return {'hell': 'Hell', 'dunkel': 'Dunkel'}
    },
    scoreOptions () {
      return ['', '10.00', '9.75', '9.00', '8.75', '8.50']
    }
  },
  watch: {
    rink: function (val) {
      const dataset = this.$store.getters.dataset(this.datasetId)
      if (!dataset || !dataset.fileName) return

      let fileName = dataset.fileName
      const queryStringIndex = fileName.indexOf('?')

      if (queryStringIndex !== -1) {
        const baseUrl = fileName.substring(0, queryStringIndex) // Extract base URL
        const queryString = fileName.substring(queryStringIndex) // Extract query string

        // Use regex to find and replace attributes.platz with the new value
        const updatedQueryString = queryString.replace(/(attributes\.platz=)\d+/, `$1${val}`)

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          })
        }
      }
    },
    recordId: function (val) {
      if (!val) return
      let record = this.$store.getters.dataset(this.datasetId).records
        .find(r => r.recordId === val)
      if (!record) return
      record = this.mapRecord(record)
      this.color1 = record.color1
      this.title1 = record.title1
      this.club1 = record.club1
      this.score1 = record.score1
      this.color2 = record.color2
      this.title2 = record.title2
      this.club2 = record.club2
      this.color2 = record.color2
      this.score2 = record.score2
    },
    color1: function (val) {
      if (!this.allowSameColor) {
        this.color2 = val === 'hell' ? 'dunkel' : 'hell'
      }
    },
    color2: function (val) {
      if (!this.allowSameColor) {
        this.color1 = val === 'hell' ? 'dunkel' : 'hell'
      }
    }
  },
  methods: {
    labelFn (record) {
      return [
        record['p1_bibNumber'] || record['p1_a_startnummer'] || '',
        record['p1_lastName'] || '',
        record['p1_firstName'] || '',
        record['p1_a_note'] || '',
        '-',
        record['p2_bibNumber'] || record['p2_a_startnummer'] || '',
        record['p2_lastName'] || '',
        record['p2_firstName'] || '',
        record['p2_a_note'] || '',
        '-',
        record['a_status']
      ].join(' ')
    },
    mapRecord (record) {
      const result = {}
      const recordMap = {
        color1: this.patternColor1,
        title1: this.patternTitle1,
        club1: this.patternClub1,
        score1: this.patternScore1,
        color2: this.patternColor2,
        title2: this.patternTitle2,
        club2: this.patternClub2,
        score2: this.patternScore2
      }
      for (let k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || ''
        })
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/swiss-wrestling-result-2024.vue